import { PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IdentityProvider, useUserContext } from '@vp/ubik-context';
import { LocalizationProvider } from '@vp/om-translations';
import { QUERY_DEFAULT_OPTIONS } from './constants/reactQueryDefaultConfig';
import { createAuthConfig } from './utils/auth';
import { ErrorProvider } from './components/contexts/ErrorContext';
import { StatusContextProvider } from './components/contexts/StatusContext';
import { InitializeNewRelic } from './newrelic/NewRelicUtilities';

export interface FragmentWrapperProps extends PropsWithChildren {
  localizations: object;
}

export const FragmentWrapper = ({
  children,
  localizations,
}: FragmentWrapperProps) => {
  const queryClient = new QueryClient();
  queryClient.setDefaultOptions(QUERY_DEFAULT_OPTIONS);
  const { locale } = useUserContext();

  return (
    <>
      <InitializeNewRelic />
      <IdentityProvider auth={createAuthConfig(locale)}>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider
            translationResources={localizations ?? {}}
            locale={locale}
            logLevel="ERROR"
          >
            <ErrorProvider>
              <StatusContextProvider>{children}</StatusContextProvider>
            </ErrorProvider>
          </LocalizationProvider>
        </QueryClientProvider>
      </IdentityProvider>
    </>
  );
};
